export const CollectionPointEndpoints = {
  LIST: '/api/admin/logistics/collection-points',
  GET: '/api/admin/logistics/collection-points/:id',
  CREATE: '/api/admin/logistics/collection-points',
  UPDATE: '/api/admin/logistics/collection-points/:id',
};
